import store from '@/store/index.js'
let dic = store.state.dic;

import { validateEmail, validatePhone, validateMoneyCorrect } from "@/libs/elementChecker.js";
export default function Configs(that) {
    // 基础信息
    const formItemsBasic1 = [
        {
            label: "考生号",
            span: 12,
            model: "examNumber",
            disabled: true
        },
        {
            label: "姓名",
            span: 12,
            model: "studentName",
            disabled: true
        },
        {
            label: "曾用名",
            span: 12,
            model: "usedName",
            //disabled: true,
            placeholder: '没有曾用名填写无',
            maxlength: 30,
            showLimit: true,
        },
        {
            label: "性别",
            span: 12,
            model: "sex",
            type: 'select',
            disabled: true,
            options: dic._SEXS
        },
        {
            label: "出生日期",
            span: 12,
            model: "dateBirth",
            type: 'date',
            disabled: true
        },
        {
            label: "民族",
            span: 12,
            model: "nationCode",
            type: "select",
            options: dic._NATION,
            disabled: true
        },
        {
            label: "籍贯",
            span: 12,
            model: "nativePlace",
            //disabled: true,
            placeholder: "以户口为准",
            maxlength: 30,
            showLimit: true,
        },
        {
            label: "身份证号",
            span: 12,
            model: "idCard",
            disabled: true
        },
        {
            label: "高考成绩",
            span: 12,
            model: "examScore",
            disabled: true
        },
        {
            label: "政治面貌",
            span: 12,
            model: "politicalCode",
            type: 'select',
            options: dic._POLITICAL,
            // disabled: true
        },
        {
            label: "入党、团年月",
            span: 12,
            model: "joinPartyTime",
            type: 'month',
        },
        {
            label: "家庭出身",
            span: 12,
            model: "familyBackgroundCode",
            type: 'select',
            options: dic._FAMILYBACKGROUND
        },

    ]
    const formItemsBasic2 = [
        // {
        //     label: "银行卡号",
        //     span: 12,
        //     model: "",
        //     disabled: true
        // },
        {
            label: "健康状况",
            span: 12,
            model: "healthConditionCode",
            type: 'select',
            options: dic._HEALTHCONDITION
        },
        {
            label: "家庭住址",
            span: 12,
            model: "addressAreaCode",
            type: 'cascader',
            options: [],
            props: {
                expandTrigger: 'hover',
                label: 'name',
                value: 'code',
                children: 'sysAreaLists',
                emitPath: false,
            },
        },
        {
            label: "家庭详细住址",
            span: 12,
            model: "addressInfo",
            maxlength: 30,
            showLimit: true,
        },

        {
            label: "家长电话",
            span: 12,
            model: "familyPhone",
        },
        {
            label: "邮编",
            span: 12,
            model: "postcode",
        },
        {
            label: "特长、爱好",
            span: 12,
            model: "hobby",
            maxlength: 30,
            showLimit: true,
        },
        {
            label: "邮箱",
            span: 12,
            model: "email",
            placeholder: '请输入'
        },
        {
            label: "本人电话",
            span: 12,
            model: "phoneNumber",
            placeholder: '请输入联系电话'
        },
        {
            label: "常用QQ",
            span: 12,
            model: "qqCode",
            placeholder: '请输入'
        },

        {
            label: "常用微信",
            span: 12,
            model: "wxCode",
            placeholder: '请输入'
        },
    ]

    const formItemsBasic3 = [
        // {
        //     label: "毕业学校",
        //     span: 8,
        //     model: "",
        //     // type: 'select',
        //     disabled: true
        // },
        {
            label: "学号",
            prop: "studentNo",
            span: 8,
            model: "studentNo",
            disabled: true
        },
        {
            label: "学院",
            span: 8,
            model: "collegeName",
            placeholder: '请选择学院',
            // type: 'select',
            disabled: true
        },
        {
            label: "系别",
            span: 8,
            model: "departmentName",
            // type: 'select',
            placeholder: '请选择系别',
            disabled: true
        },
        {
            label: "专业",
            span: 8,
            model: "majorName",
            // type: 'select',
            placeholder: '请选择专业',
            disabled: true
        },

        {
            label: "班级",
            span: 8,
            model: "className",
            // type: 'select',
            placeholder: '请选择班级',
            disabled: true
        },
        {
            label: "学制",
            span: 8,
            model: "academicYearName",
            // type: "select",
            disabled: true
        },
        {
            label: "培养层次",
            span: 8,
            model: "academicDegreeName",
            // type: 'select',
            disabled: true
        },
    ]
    const formItemsBasic4 = [
        {
            label: "贷款金额",
            span: 8,
            model: "loanAmount",
        },

    ]
    const formRules = {
        // joinPartyTime: [
        //     {
        //         required: true,
        //         message: '请选择入党、团年月',
        //         trigger: "blur"
        //     }
        // ],
        familyBackground: [
            {
                required: true,
                message: '请输入',
                trigger: "blur"
            }
        ],
        familyBackgroundCode: [
            {
                required: true,
                message: '请选择家庭出身',
                trigger: "blur"
            }
        ],
        healthCondition: [
            {
                required: true,
                message: '请选择健康状况',
                trigger: "blur"
            }
        ],
        healthConditionCode: [
            {
                required: true,
                message: '请选择健康状况',
                trigger: "blur"
            }
        ],
        addressAreaCode: [
            {
                required: true,
                message: '请选择家庭住址地区',
                trigger: "blur"
            }
        ],
        politicalCode: [
            {
                required: true,
                message: '请选择政治面貌',
                trigger: "blur"
            }
        ],
        usedName: [
            {
                required: true,
                message: '请输入曾用名',
                trigger: "blur"
            }
        ],
        nativePlace: [
            {
                required: true,
                message: '请输入籍贯',
                trigger: "blur"
            }
        ],
        addressInfo: [
            {
                required: true,
                message: '请输入家庭住址',
                trigger: "blur"
            }
        ],
        familyPhone: [{
            required: true,
            validator: validatePhone,
            trigger: "blur"
        }],
        postcode: [
            {
                required: true,
                message: '请输入邮编',
                trigger: "blur"
            }
        ],
        hobby: [
            {
                required: true,
                message: '请输入特长、爱好',
                trigger: "blur"
            }
        ],
        phoneNumber: [{
            required: true,
            validator: validatePhone,
            trigger: "blur"
        }],
        email: [{
            required: true,
            validator: validateEmail,
            trigger: "blur"
        }],
        photoUrl: [
            {
                required: true,
                message: '请上传图片',
                trigger: "change"
            }
        ],
        qqCode: [
            {
                required: true,
                message: '请输入常用QQ',
                trigger: "blur"
            }
        ],
    }



    return {
        formItemsBasic1,
        formItemsBasic2,
        formItemsBasic3,
        formItemsBasic4,
        formRules,
    }
}
